// extracted by mini-css-extract-plugin
module.exports = {"accordion":"y_h","active":"y_cl","icon":"y_bj"};